webpackJsonp([114276838955818,60335399758886],{

/***/ 201:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Lukas Pustina","description":"The website, notes, projects and publications of Lukas Pustina","siteUrl":"https://lukas.pustina.de"}}},"layoutContext":{}}

/***/ }),

/***/ 442:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(448);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(201);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 562:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var PropTypes = _interopDefault(__webpack_require__(4));
	var React = __webpack_require__(3);
	var hoistNonReactStatics = _interopDefault(__webpack_require__(306));
	
	function _extends() {
	  _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	// https://github.com/styled-components/styled-components/blob/e05b3fe247e9d956bcde786cec376e32afb85bca/src/utils/create-broadcast.js
	var createBroadcast = function createBroadcast(initialState) {
	  var listeners = {};
	  var id = 0;
	  var state = initialState;
	
	  function publish(nextState) {
	    state = nextState;
	
	    for (var key in listeners) {
	      // $FlowFixMe
	      var listener = listeners[key];
	
	      if (listener === undefined) {
	        continue;
	      }
	
	      listener(state);
	    }
	  }
	
	  function subscribe(listener) {
	    var currentId = id;
	    listeners[currentId] = listener;
	    id += 1;
	    listener(state);
	    return currentId;
	  }
	
	  function unsubscribe(unsubID) {
	    listeners[unsubID] = undefined;
	  }
	
	  return {
	    publish: publish,
	    subscribe: subscribe,
	    unsubscribe: unsubscribe
	  };
	};
	
	var channel = '__EMOTION_THEMING__';
	
	var _contextTypes;
	var contextTypes = (_contextTypes = {}, _contextTypes[channel] = PropTypes.object, _contextTypes);
	
	var isPlainObject = function isPlainObject(test) {
	  return Object.prototype.toString.call(test) === '[object Object]';
	};
	
	// Get the theme from the props, supporting both (outerTheme) => {} as well as object notation
	function getTheme(theme, outerTheme) {
	  if (typeof theme === 'function') {
	    var mergedTheme = theme(outerTheme);
	
	    if (!isPlainObject(mergedTheme)) {
	      throw new Error('[ThemeProvider] Please return an object from your theme function, i.e. theme={() => ({})}!');
	    }
	
	    return mergedTheme;
	  }
	
	  if (!isPlainObject(theme)) {
	    throw new Error('[ThemeProvider] Please make your theme prop a plain object');
	  }
	
	  if (outerTheme === undefined) {
	    return theme;
	  }
	
	  return _extends({}, outerTheme, theme);
	}
	
	var ThemeProvider =
	/*#__PURE__*/
	function (_Component) {
	  _inheritsLoose(ThemeProvider, _Component);
	
	  function ThemeProvider() {
	    return _Component.apply(this, arguments) || this;
	  }
	
	  var _proto = ThemeProvider.prototype;
	
	  _proto.componentWillMount = function componentWillMount() {
	    var _this = this;
	
	    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
	    // with the outer theme
	    if (this.context[channel] !== undefined) {
	      this.unsubscribeToOuterId = this.context[channel].subscribe(function (theme) {
	        _this.outerTheme = theme;
	
	        if (_this.broadcast !== undefined) {
	          _this.publish(_this.props.theme);
	        }
	      });
	    }
	
	    this.broadcast = createBroadcast(getTheme(this.props.theme, this.outerTheme));
	  };
	
	  _proto.getChildContext = function getChildContext() {
	    var _ref;
	
	    return _ref = {}, _ref[channel] = {
	      subscribe: this.broadcast.subscribe,
	      unsubscribe: this.broadcast.unsubscribe
	    }, _ref;
	  };
	
	  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (this.props.theme !== nextProps.theme) {
	      this.publish(nextProps.theme);
	    }
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    var themeContext = this.context[channel];
	
	    if (themeContext !== undefined) {
	      themeContext.unsubscribe(this.unsubscribeToOuterId);
	    }
	  };
	
	  _proto.publish = function publish(theme) {
	    this.broadcast.publish(getTheme(theme, this.outerTheme));
	  };
	
	  _proto.render = function render() {
	    if (!this.props.children) {
	      return null;
	    }
	
	    return React.Children.only(this.props.children);
	  };
	
	  ThemeProvider.childContextTypes = contextTypes;
	  ThemeProvider.contextTypes = contextTypes;
	  return ThemeProvider;
	}(React.Component);
	
	var withTheme = function withTheme(Component) {
	  var componentName = Component.displayName || Component.name || 'Component';
	
	  var WithTheme =
	  /*#__PURE__*/
	  function (_React$Component) {
	    _inheritsLoose(WithTheme, _React$Component);
	
	    function WithTheme(props) {
	      return _React$Component.call(this, props) || this;
	    }
	
	    var _proto = WithTheme.prototype;
	
	    _proto.componentWillMount = function componentWillMount() {
	      var _this = this;
	
	      var themeContext = this.context[channel];
	
	      if (themeContext === undefined) {
	        // eslint-disable-next-line no-console
	        console.error('[withTheme] Please use ThemeProvider to be able to use withTheme');
	        return;
	      }
	
	      this.unsubscribeId = themeContext.subscribe(function (theme) {
	        _this.setState({
	          theme: theme
	        });
	      });
	    };
	
	    _proto.componentWillUnmount = function componentWillUnmount() {
	      if (this.unsubscribeId !== -1) {
	        this.context[channel].unsubscribe(this.unsubscribeId);
	      }
	    };
	
	    _proto.render = function render() {
	      return React.createElement(Component, _extends({
	        theme: this.state.theme
	      }, this.props));
	    };
	
	    return WithTheme;
	  }(React.Component);
	
	  WithTheme.displayName = "WithTheme(" + componentName + ")";
	  WithTheme.contextTypes = contextTypes;
	  return hoistNonReactStatics(WithTheme, Component);
	};
	
	exports.ThemeProvider = ThemeProvider;
	exports.withTheme = withTheme;
	exports.channel = channel;
	exports.contextTypes = contextTypes;
	exports.createBroadcast = createBroadcast;


/***/ }),

/***/ 566:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 445:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Foot = _Layout.Flex.withComponent('footer', {
	  target: 'e1y0cw0l0'
	});
	
	var Footer = function Footer(_ref) {
	  var post = _ref.post;
	  return _react2.default.createElement(
	    Foot,
	    {
	      mt: 'auto',
	      mb: [3, 3, 4],
	      align: 'center',
	      justify: ['center', 'center', 'space-between'],
	      fontFamily: 'monospace'
	    },
	    _react2.default.createElement(
	      _Typography.List,
	      null,
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block', mr: 4 },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/legal_notice/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            {
	              color: 'lightgrey',
	              hover: { color: 'orange' },
	              fontSize: [-1, 0]
	            },
	            'Legal Notice'
	          )
	        ),
	        _react2.default.createElement(
	          _Layout.Text,
	          { color: 'lightgrey', hover: { color: 'orange' }, fontSize: [-1, 0] },
	          ' ',
	          '/',
	          ' '
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/impressum/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            {
	              color: 'lightgrey',
	              hover: { color: 'orange' },
	              fontSize: [-1, 0]
	            },
	            'Impressum'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block', mr: 4 },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/privacy_policy/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            {
	              color: 'lightgrey',
	              hover: { color: 'orange' },
	              fontSize: [-1, 0]
	            },
	            'Privacy Policy'
	          )
	        ),
	        _react2.default.createElement(
	          _Layout.Text,
	          { color: 'lightgrey', hover: { color: 'orange' }, fontSize: [-1, 0] },
	          ' ',
	          '/',
	          ' '
	        ),
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/datenschutz_erklaerung/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            {
	              color: 'lightgrey',
	              hover: { color: 'orange' },
	              fontSize: [-1, 0]
	            },
	            'Datenschutzerkl\xE4rung'
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 446:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(39);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactFontawesome = __webpack_require__(127);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	var _fontawesomeFreeSolid = __webpack_require__(126);
	
	var _Layout = __webpack_require__(19);
	
	var _Typography = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Nav = _Layout.Flex.withComponent('nav', {
	  target: 'e147ppku0'
	});
	
	var Navigation = function Navigation(_ref) {
	  var location = _ref.location;
	  return _react2.default.createElement(
	    Nav,
	    { align: 'center', justify: 'space-between', mt: [0, 2, 3], mb: [5, 6] },
	    _react2.default.createElement(
	      _Layout.Flex,
	      { align: 'center' },
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/' },
	        _react2.default.createElement(
	          _Layout.Text,
	          {
	            fontFamily: 'monospace',
	            fontSize: [0, 1],
	            color: 'black',
	            hover: { color: 'orange' },
	            px: 1,
	            pb: 1,
	            mr: 2
	          },
	          'Dr. Lukas Pustina'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Typography.List,
	      { fontFamily: 'monospace' },
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            _extends({}, location.pathname.length === 1 ? { borderBottom: 2, borderColor: 'orange' } : {}, {
	              fontSize: [0, 1],
	              color: 'black',
	              hover: { color: 'orange' },
	              px: 1,
	              pb: 0,
	              mr: 2
	            }),
	            'Home'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/notes/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            _extends({}, location.pathname.indexOf('/notes') === 0 ? { borderBottom: 2, borderColor: 'orange' } : {}, {
	              fontSize: [0, 1],
	              color: 'black',
	              hover: { color: 'orange' },
	              px: 1,
	              pb: 0,
	              mr: 2
	            }),
	            'Notes'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/projects/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            _extends({}, location.pathname.indexOf('/projects') === 0 ? { borderBottom: 2, borderColor: 'orange' } : {}, {
	              fontSize: [0, 1],
	              color: 'black',
	              hover: { color: 'orange' },
	              px: 1,
	              pb: 0,
	              mr: 2
	            }),
	            'Projects'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/publications/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            _extends({}, location.pathname.indexOf('/publications') === 0 ? { borderBottom: 2, borderColor: 'orange' } : {}, {
	              fontSize: [0, 1],
	              color: 'black',
	              hover: { color: 'orange' },
	              px: 1,
	              pb: 0,
	              mr: 2
	            }),
	            'Publications'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/about/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            _extends({}, location.pathname.indexOf('/about') === 0 ? { borderBottom: 2, borderColor: 'orange' } : {}, {
	              fontSize: [0, 1],
	              color: 'black',
	              hover: { color: 'orange' },
	              px: 1,
	              pb: 0,
	              mr: 2
	            }),
	            'About'
	          )
	        )
	      ),
	      _react2.default.createElement(
	        _Typography.ListItem,
	        { display: 'inline-block' },
	        _react2.default.createElement(
	          _gatsbyLink2.default,
	          { to: '/search/' },
	          _react2.default.createElement(
	            _Layout.Text,
	            _extends({}, location.pathname.indexOf('/search') === 0 ? { borderBottom: 2, borderColor: 'orange' } : {}, {
	              fontSize: [0, 1],
	              color: 'black',
	              hover: { color: 'orange' },
	              px: 1,
	              pb: 0
	            }),
	            _react2.default.createElement(_reactFontawesome2.default, { icon: _fontawesomeFreeSolid.faSearch })
	          )
	        )
	      )
	    )
	  );
	};
	
	exports.default = Navigation;
	module.exports = exports['default'];

/***/ }),

/***/ 448:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _reactEmotion = __webpack_require__(25);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	var _emotionTheming = __webpack_require__(562);
	
	var _fontawesome = __webpack_require__(259);
	
	var _fontawesome2 = _interopRequireDefault(_fontawesome);
	
	var _theme = __webpack_require__(463);
	
	var _theme2 = _interopRequireDefault(_theme);
	
	var _Layout = __webpack_require__(19);
	
	var _Navigation = __webpack_require__(446);
	
	var _Navigation2 = _interopRequireDefault(_Navigation);
	
	var _Footer = __webpack_require__(445);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _normalize = __webpack_require__(566);
	
	var _normalize2 = _interopRequireDefault(_normalize);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	(0, _reactEmotion.injectGlobal)('html{box-sizing:border-box;@media print{background-color:transparent;}}*,*:before,*:after{box-sizing:inherit;}::selection{background-color:', _theme2.default.colors.orange, ';}svg{fill:currentColor;}a{text-decoration:none;text-decoration-skip:ink;text-decoration-skip-ink:auto;}@media print{nav,footer{display:none !important;}}');
	
	var Backdrop = /*#__PURE__*/(0, _reactEmotion2.default)(_Layout.Box, {
	  target: 'e141gbbw0'
	})('background-position:center top;background-size:900px;@media (min-width:', function (_ref) {
	  var theme = _ref.theme;
	  return theme.breakpoints[0];
	}, 'em){background-size:1200px;}@media print{background:transparent;padding:0;}');
	// the min-height stuff here is kind of gross,
	// but I'm not sure of a way of accessing these values inside styled-system like this
	// just gotta update the step on the scale here if it's updated in <Layout />
	var Content = /*#__PURE__*/(0, _reactEmotion2.default)(_Layout.Box, {
	  target: 'e141gbbw1'
	})('min-height:calc(100vh - ', function (_ref2) {
	  var theme = _ref2.theme;
	  return theme.space[4];
	}, ');@media (min-width:', function (_ref3) {
	  var theme = _ref3.theme;
	  return theme.breakpoints[0];
	}, 'em){min-height:calc(100vh - ', function (_ref4) {
	  var theme = _ref4.theme;
	  return theme.space[5];
	}, ');}@media print{min-height:0;}');
	// have to set min-height here too
	// because otherwise the flex container isn't as tall as the content container
	// preventing the auto footer stuff from happening.
	var Constraint = /*#__PURE__*/(0, _reactEmotion2.default)(_Layout.Flex, {
	  target: 'e141gbbw2'
	})('max-width:64rem;margin-left:auto;margin-right:auto;min-height:calc(100vh - ', function (_ref5) {
	  var theme = _ref5.theme;
	  return theme.space[5];
	}, ');@media (min-width:', function (_ref6) {
	  var theme = _ref6.theme;
	  return theme.breakpoints[0];
	}, 'em){min-height:calc(100vh - ', function (_ref7) {
	  var theme = _ref7.theme;
	  return theme.space[6];
	}, ');}');
	
	var Main = _Layout.Box.withComponent('main', {
	  target: 'e141gbbw3'
	});
	
	var Layout = function Layout(_ref8) {
	  var children = _ref8.children,
	      location = _ref8.location,
	      data = _ref8.data;
	  return _react2.default.createElement(
	    _emotionTheming.ThemeProvider,
	    { theme: _theme2.default },
	    _react2.default.createElement(
	      Backdrop,
	      { p: [2, 3], bg: 'white' },
	      _react2.default.createElement(
	        _reactHelmet2.default,
	        null,
	        _react2.default.createElement(
	          'title',
	          null,
	          data.site.siteMetadata.title
	        ),
	        _react2.default.createElement('meta', { name: 'description', content: data.site.siteMetadata.description }),
	        _react2.default.createElement('meta', { name: 'theme-color', content: _theme2.default.colors.nearWhite }),
	        _react2.default.createElement('link', {
	          rel: 'apple-touch-icon',
	          sizes: '180x180',
	          href: '/apple-touch-icon.png'
	        }),
	        _react2.default.createElement('link', {
	          rel: 'icon',
	          type: 'image/png',
	          href: '/favicon-32x32.png',
	          sizes: '32x32'
	        }),
	        _react2.default.createElement('link', {
	          rel: 'icon',
	          type: 'image/png',
	          href: '/favicon-16x16.png',
	          sizes: '16x16'
	        }),
	        _react2.default.createElement('link', { rel: 'manifest', href: '/manifest.json' }),
	        _react2.default.createElement('link', {
	          rel: 'mask-icon',
	          href: '/safari-pinned-tab.svg',
	          color: _theme2.default.colors.orange
	        })
	      ),
	      _react2.default.createElement(
	        Content,
	        {
	          color: 'black',
	          bg: 'white',
	          py: 3,
	          px: [3, 4],
	          borderRadius: 2,
	          fontFamily: 'sans-serif'
	        },
	        _react2.default.createElement(
	          Constraint,
	          { flexDirection: 'column' },
	          _react2.default.createElement(_Navigation2.default, { location: location }),
	          _react2.default.createElement(
	            Main,
	            { mb: [5, 6] },
	            children()
	          ),
	          _react2.default.createElement(_Footer2.default, null)
	        )
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';
	
	exports.default = Layout;

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var breakpoints = ['48em', '64em'];
	
	var colors = {
	  black: '#443e35',
	  nearWhite: '#f9f9f8',
	  white: '#fff',
	  transparent: 'transparent',
	  orange: '#f2930d'
	
	  // Box-sizing & borders
	};var space = [0, '0.25rem', '0.5rem', '1rem', '2rem', '4rem', '8rem', '16rem'];
	var borders = [0, '0.125rem solid', '0.25rem solid', '0.5rem solid', '1rem solid', '2rem solid'];
	var radii = [0, '0.125rem', '0.25rem', '0.5rem', '1rem', '100%'];
	
	// Typography
	var fontSizes = ['0.875rem', '1rem', '1.25rem', '1.5rem', '2.25rem', '3rem', '5rem', '6rem'];
	var lineHeights = {
	  title: 1.25,
	  copy: 1.5
	};
	var fontWeights = {
	  1: '100',
	  2: '200',
	  3: '300',
	  4: '400',
	  5: '500',
	  6: '600',
	  7: '700',
	  normal: '400',
	  bold: '700'
	};
	var fonts = {
	  'sans-serif': '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
	  monospace: 'sfmono, "roboto mono", consolas, monaco, monospace'
	};
	
	var theme = {
	  breakpoints: breakpoints,
	  space: space,
	  fontSizes: fontSizes,
	  borders: borders,
	  radii: radii,
	  fonts: fonts,
	  lineHeights: lineHeights,
	  fontWeights: fontWeights,
	  colors: colors
	};
	
	exports.default = theme;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-dffdacc174d0b0206190.js